<template>
  <div class="col-7">
    <slot />
  </div>
</template>
